import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PartnersTable {
    :global(.RowLink) {
      justify-content: flex-start;
    }

    .FullNameAndIbCell {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @include respond-to(sm) {
        align-items: center;
        justify-content: center;
      }
      width: 100%;
      padding-left: 10px;
      gap: 5px;
      &__IbAccounts {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .PartnerTagsCell {
      width: 100%;
      white-space: normal;

      &__account {
        display: flex;
        align-items: center;
        gap: 6px;
        min-height: 28px;
        padding: 2px 0;
      }

      &__partner-code {
        flex: 0 0 70px;
        color: #777;
      }

      &__tags {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        align-items: center;
      }

      &__tag {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 5px 3px 8px;
        color: #fff;
        background: #28a9dc;
        border-radius: 3px;
        line-height: 1;

        button {
          width: 12px;
          height: 12px;
        }

        button {
          display: inline-flex;
          align-items: center;
          padding: 0;
          border: 0;
          background: transparent;
          color: inherit;
          cursor: pointer;
        }

        &-remove {
          position: relative;
          display: block;
          width: 12px;
          height: 12px;

          &:before,
          &:after {
            position: absolute;
            top: 5px;
            left: 0;
            width: 12px;
            height: 1px;
            background: currentColor;
            content: '';
          }

          &:before {
            transform: rotate(45deg);
          }

          &:after {
            transform: rotate(-45deg);
          }
        }
      }

      &__edit {
        display: inline-flex;
        align-items: center;
        padding: 2px;
        border: 0;
        background: transparent;
        cursor: pointer;

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    :global(.ReactDataTable) {
      tr {
        grid-template-columns:
          minmax(50px, 0.5fr) repeat(4, minmax(100px, 2fr)) repeat(6, minmax(120px, 1fr)) minmax(130px, 1fr);
        white-space: nowrap;
      }
    }

    :global(.ClientsCellWithDropDown) {
      width: 100%;
      white-space: nowrap;
    }

    :global(.ClientsCellWithDropDown__clients) {
      white-space: nowrap;
    }

    :global(img) {
      width: 35px;
      min-width: 35px;
      border-radius: 50%;
    }

    :global(.PartnersTable__masterIb) {
      width: 100%;
      display: flex;
      flex-direction: column;

      :global(.PartnersTable__masterIb-name) {
        margin-top: rem(5px);
      }
    }

    .ResponsiveTable {
      .ResponsiveTable__thead {
        min-width: 420px !important;

        span {
          flex: 60;
          text-align: center;
          padding: 5px 0;

          &:first-child {
            padding-left: 59px;
            flex: 1;
            opacity: 0;
          }

          &:nth-of-type(3) {
            text-align: left;
          }

          &:last-child {
            padding-right: 28px;
            flex: 1;
          }
        }
      }

      .ResponsiveTable__tfoot {
        .ResponsiveTable__row-details {
          &:after {
            display: none !important;
          }
        }
      }

      .ResponsiveTable__row-details {
        &:after {
          display: none !important;
        }
      }

      .ResponsiveTable__detailed-caption:hover {
        color: green;
      }
    }

    .ResponsiveTable {
      .ResponsiveTable__tbody {
        min-width: 420px !important;

        .ResponsiveTable__row-item {
          flex: 60;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            padding-left: rem(20px);
            padding-right: 5px;
            flex: 1;
          }
        }
        .ResponsiveTable__row-preview {
          padding: 9px 30px 9px 9px;
          overflow: visible !important;
          border: none !important;
          outline: none !important;

          &:before {
            content: none;
          }

          .ResponsiveTable__row-item {
            &:nth-of-type(1) {
              @include respond-to(sm) {
                padding: 0 0 0 0;
              }
            }

            &:nth-of-type(3) {
              overflow: hidden;
              text-align: left;
              justify-content: flex-start;
            }
          }
          .ResponsiveTable__preview-main {
            height: max-content !important;
          }
        }

        .ResponsiveTable__row-details {
          overflow: visible !important;
          border: none !important;
          outline: none !important;

          &:before {
            content: none;
          }

          .ResponsiveTable__details-item {
            padding-left: 22%;
          }
        }
      }
    }
  }

  .PartnersTable__confirm-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0;
    width: 100%;
    max-width: 320px;
    margin: 25px auto 0;

    > .DefaultButton {
      flex: 1 1 0;
      min-width: 0;
    }

    > button + button {
      margin-left: 60px;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PartnersTable {
      :global(.PartnersTable__masterIb-name) {
        color: ${colors.gray.hex};
      }
      :global(.FullNameAndIbCell__IbAccount) {
        color: ${colors.gray.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
